import { render, staticRenderFns } from "./VaColorSquare.vue?vue&type=template&id=3a94e58a&"
import script from "./VaColorSquare.vue?vue&type=script&lang=js&"
export * from "./VaColorSquare.vue?vue&type=script&lang=js&"
import style0 from "./VaColorSquare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports